import { createI18n } from 'vue-i18n';

/* eslint-disable */
const i18n = createI18n({
  legacy: true,
  locale: 'en_US',
  fallbackLocale: 'en_US',
  messages: {},
  globalInjection: true,
  warnHtmlMessage: false,
  missingWarn: false,
  fallbackWarn: false,
});

// 兼容旧版 VueI18n API，方便现有代码继续通过 i18n.t / i18n.locale 访问
i18n.t = (...args) => i18n.global.t(...args);
i18n.mergeLocaleMessage = (...args) => i18n.global.mergeLocaleMessage(...args);
Object.defineProperty(i18n, 'locale', {
  get() {
    return i18n.global.locale;
  },
  set(value) {
    i18n.global.locale = value;
  },
});

export default i18n;
